import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import FormDataProvider from "../../formValues/ui/FormDataProvider";
import ApplicationFormProvider from "../../applicationForm/ui/ApplicationFormProvider";
import ScrollToTop from "shared/ui/ScrollToTop/ScrollToTop";
import NavigationProvider from './NavigationProvider';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import HomePage from 'pages/HomePage/HomePage';
import { AppRoutes, RoutePath } from 'shared/config/routeConfig/routeConfig';
import CheckoutPage from 'pages/CheckoutPage/CheckoutPage';
import QuestionsPage from 'pages/QuestionsPage/QuestionsPage';
import QuotePage from 'pages/QuotePage/QuotePage';
import SummaryPage from 'pages/SummaryPage/SummaryPage';
import ErrorPage from 'pages/ErrorPage/ErrorPage';
import ThemeSettingsWrapper from 'app/providers/theme/ui/ThemeSettingsWrapper';
import ConfirmationPage from 'pages/ConfirmationPage/ConfirmationPage';
import NotFoundPage from '../../../../pages/NotFoundPage/NotFoundPage';

const client = new QueryClient(
	{
		defaultOptions: {
			queries: {
				gcTime: Infinity
			}
		}
	}
)
const AppRouter = () => {
	return (
		<QueryClientProvider client={client}>
			<LocalizationProvider dateAdapter={AdapterDateFns}>
				<NavigationProvider>
					<ApplicationFormProvider>
						<FormDataProvider>
							<ThemeSettingsWrapper>
								<Routes>
									<Route path="/" element={<HomePage/>}>
										<Route path={RoutePath[AppRoutes.CHECKOUT]} element={<CheckoutPage/>}/>
										<Route path={RoutePath[AppRoutes.QUESTIONS]} element={<QuestionsPage/>}/>
										<Route index element={<QuotePage/>}/>
									</Route>
									<Route path={RoutePath[AppRoutes.SUMMARY]} element={<SummaryPage/>}/>
									<Route path={RoutePath[AppRoutes.CONFIRMATION]} element={<ConfirmationPage/>}/>
									<Route path={RoutePath[AppRoutes.ERROR]} element={<ErrorPage/>}/>
									<Route path={RoutePath[AppRoutes.NOT_FOUND]} element={<NotFoundPage/>}/>
								</Routes>
							</ThemeSettingsWrapper>
							<ScrollToTop/>
						</FormDataProvider>
					</ApplicationFormProvider>
				</NavigationProvider>
			</LocalizationProvider>
		</QueryClientProvider>
	)
}

export default AppRouter
